import { render, staticRenderFns } from "./LaboratoryConfiguration.vue?vue&type=template&id=35276aa8&"
import script from "./LaboratoryConfiguration.vue?vue&type=script&lang=js&"
export * from "./LaboratoryConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports